import React, { useEffect, useState } from "react";
import taxImage from "../../images/loginImage.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { tr } from "framer-motion/client";
import { apiClient } from "../../lib/apiClient";
import { useAuth } from "../../context/AuthContext";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); 
  const navigate = useNavigate();
  const { login } = useAuth();
const { t, i18n } = useTranslation(); // Destructure i18n here
const location = useLocation(); // Add this hook
  const { lang } = useParams();
   const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await apiClient.post("auth/login", { email, password });
      await login(response.data); 
      navigate(i18n.language === "en" ? "/admin/en/crm/lead" : "/admin/crm/lead");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

useEffect(() => {
  // Logic: 
  // 1. Check if 'lang' param exists from route (:lang)
  // 2. OR check if the URL path starts with /en/
  const urlLang = location.pathname.split('/')[1];
  const currentLang = lang || (urlLang === 'en' ? 'en' : 'de');

  if (i18n.language !== currentLang) {
    i18n.changeLanguage(currentLang);
  }
}, [lang, location.pathname, i18n]);

  return (
    <section className="w-full min-h-screen bg-white">
      <div className="grid min-h-screen grid-cols-1 md:grid-cols-2">
        {/* Left Side: Full Height Cover Image */}
        <div className="relative hidden w-full h-full md:block">
          <img
            src={taxImage}
            alt="login"
            className="absolute inset-0 object-cover w-full h-full"
          />
        </div>

        {/* Right Side: Form Content */}
        <div className="relative flex flex-col items-center justify-center p-8 bg-white md:p-16 lg:p-24">
          <div
  className="absolute top-5 left-8 flex items-center gap-1 cursor-pointer z-10"
  onClick={() => navigate(`/${i18n.language}`)}
>
            <ArrowLeft size={14} className="text-primary" />
            <span className="text-sm font-medium text-primary underline">
              {t("backToHome")}
            </span>
          </div>
          {/* Logo - Centered */}
          <div className="mb-10 text-center">
            <h1 className="font-poppins font-black text-2xl md:text-4xl text-black uppercase">
             
             <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2 font-poppins font-black text-base md:text-lg tracking-[0.1em] text-black uppercase no-underline shrink-0"
            >
              <img
                 src="/images/swiss_taxfile_logo.webp"
                alt="SwissTaxFile Logo"
                className="h-6 w-auto md:h-12"
              />
            </a>
            </h1>
          </div>

          {/* Login Form Container */}
          <div className="w-full max-w-sm">
            <div className="mb-8">
              <h1 className="mb-2 text-3xl font-bold text-slate-900">
                {t("welcomeBack")}
              </h1>
              <p className="text-sm text-slate-500">
                {t("loginDescription")}
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-5">
              {/* User ID Input */}
              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-bold text-black">{t("userId")}</label>
                <input
                  value={email} // Fixed: State variable use karein
                  onChange={(e) => setEmail(e.target.value)}
                  type="text"
                  required
                  placeholder="example@gmail.com"
                  className="w-full p-3.5 transition-all border outline-none border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-primary"
                />
              </div>

              {/* Password Input */}
              <div className="flex flex-col gap-1.5">
                <label className="text-sm font-bold text-black">{t("loginPassword")}</label>
                <input
                  value={password} // Fixed: State variable use karein
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  required
                  placeholder="********"
                  className="w-full p-3.5 transition-all border outline-none border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-primary"
                />
              </div>

              {/* Sign In Button */}
              <button
                type="submit"
                className="w-full py-3.5 mt-4 font-bold text-white transition-all shadow-lg bg-primary rounded-xl hover:opacity-90 active:scale-[0.98] shadow-blue-100"
              >
                {t("signIn")}
              </button>
            </form>

            {/* Bottom Credit / Footer Text */}
            {/* <p className="mt-12 text-xs text-center text-slate-400">
              Lorem ipsum text will be written here
            </p> */}
          </div>  
        </div>
      </div>
    </section>
  );
}
